import $ from "jquery";
import debug from 'bows/dist/bows.min.js';


const log = debug("certification-process");
let $filter_fill = $('.certification-process [data-type="section-toggle"]');
let $certification_process_section = $('.certification-process-section');
let $filter__dropdown = $filter_fill.find('.filter__dropdown');
let $filter__toggle__text = $filter_fill.find('.filter__toggle__text');
let titles = [];


function fill_filter() {
	titles.forEach(title => {
		log(title)
		$filter__dropdown.append(`
		<li className="filter__item">
			<button type="button" className="filter__trigger">${title}</button>
		</li>`);
	})
}



$(function () {
	if ($certification_process_section.length) {
		$certification_process_section.each(function () {
			let title = $(this).data('title');
			log(title);
			if (title !== null && title !== undefined && title !== '') {
				titles.push(title);
			}
		});
	}

	fill_filter();

	if (titles.length) {
		$filter__toggle__text.text(titles[0]);
	}

	if (titles.length > 1) {
		$('.filter--certification-process').removeClass('filter--certification-process');
	}

})

